
import React, { useEffect, useState } from "react";
import {
  X,
  Clock,
  User,
  Phone,
  MapPin,
  Video,
  Pencil
} from "lucide-react";

import HolidayEditModal from "../common/HolidayEditModal";

const getLeaveTypeColor = (leaveTypeCode) => {
  const colors = {
    ANNUEL: { bg: "#dbeafe", text: "#1e40af", border: "#3b82f6" },
    MALADIE: { bg: "#fee2e2", text: "#dc2626", border: "#ef4444" },
    RECUPERATION: { bg: "#f3f4f6", text: "#4b5563", border: "#6b7280" },
    MARIAGE: { bg: "#fed7aa", text: "#c2410c", border: "#f97316" },
    NOUVEAU_NE: { bg: "#e9d5ff", text: "#7c3aed", border: "#8b5cf6" },
    DECES_PROCHE: { bg: "#fecaca", text: "#b91c1c", border: "#ef4444" },
    DECES_FAMILLE: { bg: "#fecdd3", text: "#be123c", border: "#f43f5e" },
    CIRCONCISION: { bg: "#fef9c3", text: "#854d0e", border: "#eab308" }
  };

  return (
    colors[leaveTypeCode] || {
      bg: "#e5e7eb",
      text: "#374151",
      border: "#6b7280"
    }
  );
};

const getHolidayTypeColor = (holidayType) => {
  const colors = {
    NATIONAL: {
      bg: "#dcfce7",
      text: "#166534",
      border: "#22c55e"
    },
    RELIGIOUS: {
      bg: "#fef9c3",
      text: "#854d0e",
      border: "#eab308"
    },
    INTERNE_ENTREPRISE: {
      bg: "#e0e7ff",
      text: "#3730a3",
      border: "#6366f1"
    }
  };

  return (
    colors[holidayType] || {
      bg: "#e5e7eb",
      text: "#374151",
      border: "#6b7280"
    }
  );
};

const getEventColor = (event) => {
  if (event.event_type === "HOLIDAY") {
    return getHolidayTypeColor(
      event.details?.holiday_type
    ).bg;
  }

  if (event.event_type === "LEAVE") {
    return getLeaveTypeColor(
      event.details?.leave_type_code
    ).bg;
  }

  if (event.event_type === "INTERVIEW") {
    return event.status === "SCHEDULED"
      ? "#f3e8ff"
      : "#fee2e2";
  }

  const customColors = {
    HR_EVENT: "#bfdbfe",
    MEETING: "#ffedd5",
    TRAINING: "#dcfce7"
  };

  return (
    customColors[event.event_type] ||
    "#e5e7eb"
  );
};

const CalendarYearView = ({
  year,
  events,
  user,
  onEdit
}) => {
  const [selectedDayEvents, setSelectedDayEvents] =
    useState(null);

  const [calendarEvents, setCalendarEvents] =
    useState(events || []);

  const [editingHoliday, setEditingHoliday] =
    useState(null);

  // ============================================================
  // LOG INITIAL
  // ============================================================

  console.log(
    "================================================="
  );

  console.log(
    "[CalendarYearView] RENDER"
  );

  console.log(
    "[CalendarYearView] year =",
    year
  );

  console.log(
    "[CalendarYearView] user =",
    user
  );

  console.log(
    "[CalendarYearView] user.role =",
    user?.role
  );

  console.log(
    "[CalendarYearView] events =",
    events
  );

  console.log(
    "[CalendarYearView] calendarEvents =",
    calendarEvents
  );

  console.log(
    "[CalendarYearView] editingHoliday =",
    editingHoliday
  );

  console.log(
    "[CalendarYearView] selectedDayEvents =",
    selectedDayEvents
  );

  console.log(
    "================================================="
  );

  // ============================================================
  // LOG USER / ROLE
  // ============================================================

  useEffect(() => {
    console.log(
      "[CalendarYearView] USER CHANGE:",
      user
    );

    console.log(
      "[CalendarYearView] ROLE:",
      user?.role
    );
  }, [user]);

  // ============================================================
  // LOG EVENTS
  // ============================================================

  useEffect(() => {
    console.log(
      "[CalendarYearView] EVENTS reçus:",
      events
    );

    console.log(
      "[CalendarYearView] Nombre événements:",
      events?.length || 0
    );

    const holidays =
      (events || []).filter(
        (event) =>
          event.event_type === "HOLIDAY"
      );

    console.log(
      "[CalendarYearView] JOURS FÉRIÉS:",
      holidays
    );

    holidays.forEach((holiday) => {
      console.log(
        "[CalendarYearView] HOLIDAY:",
        {
          id: holiday.id,
          title: holiday.title,
          start: holiday.start,
          end: holiday.end,
          event_type: holiday.event_type,
          details: holiday.details
        }
      );
    });

    setCalendarEvents(events || []);
  }, [events]);

  // ============================================================
  // MOIS
  // ============================================================

  const months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre"
  ];

  const weekdays = [
    "L",
    "M",
    "M",
    "J",
    "V",
    "S",
    "D"
  ];

  const getDaysInMonth = (
    month,
    year
  ) => {
    return new Date(
      year,
      month + 1,
      0
    ).getDate();
  };

  const getFirstDayOfMonth = (
    month,
    year
  ) => {
    let day = new Date(
      year,
      month,
      1
    ).getDay();

    return day === 0
      ? 6
      : day - 1;
  };

  // ============================================================
  // ÉVÉNEMENTS D'UN JOUR
  // ============================================================

  const getEventsForDay = (
    dateStr
  ) => {
    const currentDate =
      new Date(dateStr);

    const result =
      calendarEvents.filter(
        (event) => {
          if (
            event.event_type ===
            "INTERVIEW"
          ) {
            return (
              event.start ===
              dateStr
            );
          }

          const start =
            new Date(event.start);

          const end =
            new Date(event.end);

          start.setHours(
            0,
            0,
            0,
            0
          );

          end.setHours(
            0,
            0,
            0,
            0
          );

          currentDate.setHours(
            0,
            0,
            0,
            0
          );

          return (
            currentDate >=
              start &&
            currentDate <=
              end
          );
        }
      );

    return result;
  };

  // ============================================================
  // CLIC SUR UN JOUR
  // ============================================================

  const handleDayClick = (
    dayEvents,
    dateStr
  ) => {
    console.log(
      "[CalendarYearView] CLIC JOUR:",
      dateStr
    );

    console.log(
      "[CalendarYearView] Événements du jour:",
      dayEvents
    );

    if (
      dayEvents.length === 0
    ) {
      console.log(
        "[CalendarYearView] Aucun événement."
      );

      return;
    }

    const holidays =
      dayEvents.filter(
        (event) =>
          event.event_type ===
          "HOLIDAY"
      );

    console.log(
      "[CalendarYearView] HOLIDAYS du jour:",
      holidays
    );

    setSelectedDayEvents({
      date: dateStr,
      events: dayEvents
    });
  };

  // ============================================================
  // VÉRIFICATION RH
  // ============================================================

  const isRH =
    user?.role === "RH" ||
    user?.role === "rh" ||
    user?.role === "ROLE_RH";

  console.log(
    "[CalendarYearView] Vérification RH:",
    {
      role: user?.role,
      isRH: isRH
    }
  );

  // ============================================================
  // MODIFIER UN JOUR FÉRIÉ
  // ============================================================

  const handleEditHoliday = (
    event
  ) => {
    console.log(
      "================================================="
    );

    console.log(
      "[CalendarYearView] CLIC SUR MODIFIER"
    );

    console.log(
      "[CalendarYearView] Event:",
      event
    );

    console.log(
      "[CalendarYearView] event.id:",
      event?.id
    );

    console.log(
      "[CalendarYearView] event.title:",
      event?.title
    );

    console.log(
      "[CalendarYearView] event.event_type:",
      event?.event_type
    );

    console.log(
      "[CalendarYearView] user:",
      user
    );

    console.log(
      "[CalendarYearView] role:",
      user?.role
    );

    console.log(
      "[CalendarYearView] isRH:",
      isRH
    );

    if (
      event.event_type !==
      "HOLIDAY"
    ) {
      console.warn(
        "[CalendarYearView] Ce n'est PAS un jour férié."
      );

      return;
    }

    console.log(
      "[CalendarYearView] Fermeture des détails..."
    );

    setSelectedDayEvents(
      null
    );

    console.log(
      "[CalendarYearView] Ouverture de HolidayEditModal..."
    );

    setEditingHoliday(event);

    console.log(
      "[CalendarYearView] editingHoliday devrait être:",
      event
    );

    console.log(
      "================================================="
    );
  };

  // ============================================================
  // SAUVEGARDE JOUR FÉRIÉ
  // ============================================================

  const handleHolidaySaved = (
    updatedHoliday
  ) => {
    console.log(
      "================================================="
    );

    console.log(
      "[CalendarYearView] JOUR FÉRIÉ MODIFIÉ"
    );

    console.log(
      "[CalendarYearView] updatedHoliday:",
      updatedHoliday
    );

    console.log(
      "[CalendarYearView] ID:",
      updatedHoliday?.id
    );

    console.log(
      "[CalendarYearView] Nom:",
      updatedHoliday?.name
    );

    console.log(
      "[CalendarYearView] Date:",
      updatedHoliday?.date
    );

    console.log(
      "[CalendarYearView] Durée:",
      updatedHoliday?.duration_days
    );

    console.log(
      "[CalendarYearView] Type:",
      updatedHoliday?.holiday_type
    );

    setCalendarEvents(
      (prevEvents) =>
        prevEvents.map(
          (event) => {
            const eventHolidayId =
              String(
                event.id
              ).replace(
                "holiday-",
                ""
              );

            const updatedHolidayId =
              String(
                updatedHoliday.id
              );

            console.log(
              "[CalendarYearView] Comparaison IDs:",
              {
                eventId:
                  event.id,
                eventHolidayId,
                updatedHolidayId
              }
            );

            if (
              event.event_type ===
                "HOLIDAY" &&
              eventHolidayId ===
                updatedHolidayId
            ) {
              console.log(
                "[CalendarYearView] Événement HOLIDAY trouvé et mis à jour."
              );

              const duration =
                Number(
                  updatedHoliday.duration_days
                ) || 1;

              const startDate =
                new Date(
                  updatedHoliday.date
                );

              const endDate =
                new Date(
                  startDate
                );

              endDate.setDate(
                endDate.getDate() +
                  duration -
                  1
              );

              const formatDate =
                (date) =>
                  date
                    .toISOString()
                    .split(
                      "T"
                    )[0];

              return {
                ...event,

                title:
                  updatedHoliday.name,

                start:
                  updatedHoliday.date,

                end:
                  formatDate(
                    endDate
                  ),

                status:
                  updatedHoliday.is_active
                    ? "ACTIVE"
                    : "INACTIVE",

                details: {
                  ...event.details,

                  holiday_type:
                    updatedHoliday.holiday_type
                }
              };
            }

            return event;
          }
        )
    );

    console.log(
      "[CalendarYearView] Fermeture modale édition."
    );

    setEditingHoliday(
      null
    );

    setSelectedDayEvents(
      null
    );

    console.log(
      "================================================="
    );
  };

  // ============================================================
  // RENDU
  // ============================================================

  return (
    <div>

      {/* ======================================================
          CALENDRIER ANNUEL
      ====================================================== */}

      <div
        className="year-grid"
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "20px"
        }}
      >

        {months.map(
          (
            monthName,
            monthIndex
          ) => {

            const daysInMonth =
              getDaysInMonth(
                monthIndex,
                year
              );

            const firstDay =
              getFirstDayOfMonth(
                monthIndex,
                year
              );

            const cells = [];

            // Jours vides
            for (
              let i = 0;
              i < firstDay;
              i++
            ) {
              cells.push(
                <div
                  key={`empty-${i}`}
                  className="month-day empty"
                />
              );
            }

            // Jours du mois
            for (
              let d = 1;
              d <= daysInMonth;
              d++
            ) {

              const dateStr =
                `${year}-${String(
                  monthIndex + 1
                ).padStart(
                  2,
                  "0"
                )}-${String(
                  d
                ).padStart(
                  2,
                  "0"
                )}`;

              const dayEvents =
                getEventsForDay(
                  dateStr
                );

              const hasEvents =
                dayEvents.length >
                0;

              const bgColor =
                hasEvents
                  ? getEventColor(
                      dayEvents[0]
                    )
                  : "transparent";

              cells.push(
                <div
                  key={`day-${d}`}
                  className={`month-day ${
                    hasEvents
                      ? "has-events"
                      : ""
                  }`}
                  style={{
                    textAlign:
                      "center",
                    padding: "4px",
                    borderRadius:
                      "4px",
                    fontSize:
                      "0.85rem",
                    cursor:
                      hasEvents
                        ? "pointer"
                        : "default",
                    backgroundColor:
                      bgColor,
                    position:
                      "relative",
                    border:
                      hasEvents
                        ? "1px solid rgba(0,0,0,0.1)"
                        : "1px solid transparent"
                  }}
                  onClick={() =>
                    handleDayClick(
                      dayEvents,
                      dateStr
                    )
                  }
                  title={
                    hasEvents
                      ? `${dayEvents.length} événement(s)`
                      : ""
                  }
                >
                  {d}

                  {hasEvents &&
                    dayEvents.length >
                      1 && (
                      <div
                        style={{
                          position:
                            "absolute",
                          bottom:
                            "0px",
                          right:
                            "2px",
                          fontSize:
                            "10px",
                          fontWeight:
                            "bold"
                        }}
                      >
                        +
                      </div>
                    )}
                </div>
              );
            }

            return (
              <div
                key={monthName}
                className="month-card card"
                style={{
                  padding:
                    "15px"
                }}
              >

                <h3
                  style={{
                    textAlign:
                      "center",
                    marginBottom:
                      "10px",
                    fontSize:
                      "1rem",
                    color:
                      "#334155"
                  }}
                >
                  {monthName}
                </h3>

                <div
                  style={{
                    display:
                      "grid",
                    gridTemplateColumns:
                      "repeat(7, 1fr)",
                    gap: "2px",
                    marginBottom:
                      "5px"
                  }}
                >
                  {weekdays.map(
                    (
                      wd,
                      i
                    ) => (
                      <div
                        key={i}
                        style={{
                          textAlign:
                            "center",
                          fontSize:
                            "0.75rem",
                          color:
                            "#64748b",
                          fontWeight:
                            "600"
                        }}
                      >
                        {wd}
                      </div>
                    )
                  )}
                </div>

                <div
                  style={{
                    display:
                      "grid",
                    gridTemplateColumns:
                      "repeat(7, 1fr)",
                    gap: "2px"
                  }}
                >
                  {cells}
                </div>

              </div>
            );
          }
        )}

      </div>

      {/* ======================================================
          MODALE DÉTAILS
      ====================================================== */}

      {selectedDayEvents && (
        <div
          className="modal-overlay"
          onClick={() =>
            setSelectedDayEvents(
              null
            )
          }
        >

          <div
            className="modal-form"
            onClick={(e) =>
              e.stopPropagation()
            }
            style={{
              maxWidth:
                "500px",
              maxHeight:
                "80vh",
              overflowY:
                "auto"
            }}
          >

            <div
              className="form-header"
              style={{
                display:
                  "flex",
                justifyContent:
                  "space-between",
                alignItems:
                  "center"
              }}
            >

              <h3>
                Événements du{" "}
                {new Date(
                  selectedDayEvents.date
                ).toLocaleDateString(
                  "fr-FR"
                )}
              </h3>

              <button
                type="button"
                onClick={() =>
                  setSelectedDayEvents(
                    null
                  )
                }
                className="btn-close"
              >
                <X size={20} />
              </button>

            </div>

            <div
              style={{
                padding:
                  "20px"
              }}
            >

              {selectedDayEvents.events.map(
                (
                  event,
                  idx
                ) => {

                  console.log(
                    "[CalendarYearView] Rendu événement modal:",
                    event
                  );

                  return (
                    <div
                      key={
                        event.id ||
                        idx
                      }
                      style={{
                        padding:
                          "15px",
                        marginBottom:
                          "15px",
                        borderRadius:
                          "8px",
                        backgroundColor:
                          getEventColor(
                            event
                          ),
                        border:
                          "1px solid rgba(0,0,0,0.05)"
                      }}
                    >

                      {/* TITRE */}

                      <div
                        style={{
                          fontWeight:
                            "600",
                          fontSize:
                            "1.05rem",
                          marginBottom:
                            "8px"
                        }}
                      >
                        {event.title}
                      </div>

                      {/* ==================================================
                          CONGÉ
                      ================================================== */}

                      {event.event_type ===
                        "LEAVE" && (
                        <div
                          style={{
                            fontSize:
                              "0.9rem",
                            color:
                              "#334155"
                          }}
                        >

                          <p
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                              gap:
                                "6px"
                            }}
                          >
                            <User
                              size={
                                14
                              }
                            />

                            {
                              event
                                .details
                                ?.employee
                            }
                          </p>

                          <p>
                            <strong>
                              Type :
                            </strong>{" "}
                            {
                              event
                                .details
                                ?.leave_type
                            }
                          </p>

                          <p>
                            <strong>
                              Statut :
                            </strong>{" "}
                            {
                              event.status
                            }
                          </p>

                          <p>
                            <strong>
                              Durée :
                            </strong>{" "}
                            {
                              event
                                .details
                                ?.duration_days
                            }{" "}
                            jour(s)
                          </p>

                        </div>
                      )}

                    
                        {/* ==================================================
                            JOUR FÉRIÉ
                        ================================================== */}

                        {event.event_type === "HOLIDAY" && (
                          <div
                            style={{
                              marginTop: "12px",
                              padding: "16px",
                              backgroundColor: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: "10px",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                            }}
                          >
                            {/* En-tête */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "14px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <span style={{ fontSize: "22px" }}>🎉</span>

                                <strong
                                  style={{
                                    fontSize: "16px",
                                    color: "#1e293b",
                                  }}
                                >
                                  Jour férié
                                </strong>
                              </div>

                              {/* Statut */}
                              <span
                                style={{
                                  padding: "4px 10px",
                                  borderRadius: "20px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  backgroundColor:
                                    event.status === "ACTIVE"
                                      ? "#dcfce7"
                                      : "#fee2e2",
                                  color:
                                    event.status === "ACTIVE"
                                      ? "#166534"
                                      : "#991b1b",
                                }}
                              >
                                {event.status === "ACTIVE"
                                  ? "Actif"
                                  : "Inactif"}
                              </span>
                            </div>

                            {/* Informations */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "10px",
                              }}
                            >
                              {/* Type */}
                              <div
                                style={{
                                  padding: "10px 12px",
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#64748b",
                                    marginBottom: "4px",
                                    textTransform: "uppercase",
                                    fontWeight: "600",
                                  }}
                                >
                                  Type
                                </div>

                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#334155",
                                  }}
                                >
                                  {event.details?.holiday_type || "Non spécifié"}
                                </div>
                              </div>

                              {/* Date */}
                              <div
                                style={{
                                  padding: "10px 12px",
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#64748b",
                                    marginBottom: "4px",
                                    textTransform: "uppercase",
                                    fontWeight: "600",
                                  }}
                                >
                                  Date
                                </div>

                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#334155",
                                  }}
                                >
                                  📅{" "}
                                  {event.start
                                    ? new Date(event.start).toLocaleDateString(
                                        "fr-FR",
                                        {
                                          day: "2-digit",
                                          month: "long",
                                          year: "numeric",
                                        }
                                      )
                                    : "Non spécifiée"}
                                </div>
                              </div>

                              {/* ID */}
                              <div
                                style={{
                                  padding: "10px 12px",
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#64748b",
                                    marginBottom: "4px",
                                    textTransform: "uppercase",
                                    fontWeight: "600",
                                  }}
                                >
                                  Identifiant
                                </div>

                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontFamily: "monospace",
                                    color: "#475569",
                                  }}
                                >
                                  {event.id}
                                </div>
                              </div>

                              {/* Durée */}
                              <div
                                style={{
                                  padding: "10px 12px",
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#64748b",
                                    marginBottom: "4px",
                                    textTransform: "uppercase",
                                    fontWeight: "600",
                                  }}
                                >
                                  Durée
                                </div>

                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#334155",
                                  }}
                                >
                                  {event.details?.duration_days ||
                                    event.duration_days ||
                                    1}{" "}
                                  jour
                                  {(event.details?.duration_days ||
                                    event.duration_days ||
                                    1) > 1
                                    ? "s"
                                    : ""}
                                </div>
                              </div>
                            </div>

                            {/* Bouton Modifier */}
                            {isRH ? (
                              <button
                                type="button"
                                onClick={() => handleEditHoliday(event)}
                                style={{
                                  marginTop: "14px",
                                  width: "100%",
                                  padding: "10px 14px",
                                  backgroundColor: "#2563eb",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "7px",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  transition: "background-color 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "#1d4ed8";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "#2563eb";
                                }}
                              >
                                <Pencil size={15} />
                                Modifier le jour férié
                              </button>
                            ) : (
                              <div
                                style={{
                                  marginTop: "14px",
                                  padding: "10px",
                                  backgroundColor: "#fff7ed",
                                  border: "1px solid #fed7aa",
                                  borderRadius: "8px",
                                  color: "#9a3412",
                                  fontSize: "13px",
                                  textAlign: "center",
                                }}
                              >
                                🔒 Modification réservée au service RH
                              </div>
                            )}
                          </div>
                        )}


                      {/* ==================================================
                          ENTRETIEN
                      ================================================== */}

                      {event.event_type ===
                        "INTERVIEW" && (
                        <div
                          style={{
                            fontSize:
                              "0.9rem",
                            color:
                              "#334155"
                          }}
                        >

                          <p
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                              gap:
                                "6px"
                            }}
                          >
                            <User
                              size={
                                14
                              }
                            />

                            {
                              event
                                .details
                                ?.candidate_name
                            }
                          </p>

                          <p>
                            <strong>
                              Offre :
                            </strong>{" "}
                            {
                              event
                                .details
                                ?.job_offer
                            }
                          </p>

                          <p
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                              gap:
                                "6px"
                            }}
                          >
                            <Clock
                              size={
                                14
                              }
                            />

                            {
                              event.start_time
                            }{" "}
                            -{" "}
                            {
                              event.end_time
                            }
                          </p>

                          <p
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                              gap:
                                "6px"
                            }}
                          >

                            {event
                              .details
                              ?.mode ===
                            "VIDEO" ? (
                              <Video
                                size={
                                  14
                                }
                              />
                            ) : event
                                .details
                                ?.mode ===
                              "PHONE" ? (
                              <Phone
                                size={
                                  14
                                }
                              />
                            ) : (
                              <MapPin
                                size={
                                  14
                                }
                              />
                            )}

                            {
                              event
                                .details
                                ?.mode
                            }

                          </p>

                        </div>
                      )}

                      {/* ==================================================
                          AUTRES
                      ================================================== */}

                      {![
                        "LEAVE",
                        "HOLIDAY",
                        "INTERVIEW"
                      ].includes(
                        event.event_type
                      ) && (
                        <div
                          style={{
                            fontSize:
                              "0.9rem",
                            color:
                              "#334155"
                          }}
                        >

                          <p>
                            <strong>
                              Type :
                            </strong>{" "}
                            {
                              event.event_type
                            }
                          </p>

                          {event.start_time && (
                            <p
                              style={{
                                display:
                                  "flex",
                                alignItems:
                                  "center",
                                gap:
                                  "6px"
                              }}
                            >
                              <Clock
                                size={
                                  14
                                }
                              />

                              {
                                event.start_time
                              }
                            </p>
                          )}

                          {event
                            .details
                            ?.employee && (
                            <p
                              style={{
                                display:
                                  "flex",
                                alignItems:
                                  "center",
                                gap:
                                  "6px"
                              }}
                            >
                              <User
                                size={
                                  14
                                }
                              />

                              Par :{" "}
                              {
                                event
                                  .details
                                  .employee
                              }
                            </p>
                          )}

                        </div>
                      )}

                    </div>
                  );
                }
              )}

            </div>
          </div>
        </div>
      )}

      {/* ======================================================
          MODALE MODIFICATION
      ====================================================== */}

      {editingHoliday && (
        <HolidayEditModal
          holiday={editingHoliday}
          onClose={() => {
            console.log(
              "[CalendarYearView] Fermeture HolidayEditModal"
            );

            setEditingHoliday(
              null
            );
          }}
          onSaved={
            handleHolidaySaved
          }
        />
      )}

    </div>
  );
};

export default CalendarYearView;

